import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '& input + .MuiInputAdornment-positionEnd > button': {
            minWidth: '1.5rem',
            width: '1.5rem',
            height: '1.5rem',
            padding: '0',
            '&:not(:last-child)': { marginRight: '0.3125rem' },
        },
        '& input[type="password"]': {
            letterSpacing: 3,
            '&::placeholder': {
                letterSpacing: 'normal',
            },
        },
        '& fieldset > legend': {
            width: 0,
        },
        '& .MuiFormHelperText-root': Object.assign(Object.assign({}, theme.typography.body3), { color: theme.colors.text[600], marginLeft: 0, '&.Mui-focused': {
                color: theme.colors.primary.main,
            }, '&.Mui-error': {
                color: theme.colors.error.main,
            } }),
    },
    rootBoundary: {
        display: 'flex',
        flexDirection: 'column',
    },
    inputRoot: {
        '&.Mui-disabled': {
            backgroundColor: theme.colors.gray.neutral,
        },
        borderRadius: 8,
        '&.MuiInputBase-adornedStart': {
            backgroundColor: theme.colors.primary.contrastWhite,
            paddingLeft: '8px',
            '&.Mui-disabled': {
                color: theme.colors.text[600],
                backgroundColor: theme.colors.gray[0],
            },
        },
        '&.MuiInputBase-adornedEnd': {
            backgroundColor: theme.colors.primary.contrastWhite,
            paddingRight: '8px',
            '&.Mui-disabled': {
                '&&': {
                    color: theme.colors.text[600],
                    backgroundColor: theme.colors.gray.neutral,
                },
            },
        },
        '& fieldset': {
            borderColor: theme.colors.gray[200],
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.error.main,
        },
    },
    input: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.colors.text[900], backgroundColor: theme.colors.primary.contrastWhite, '&.Mui-disabled': {
            backgroundColor: theme.colors.gray.neutral,
        }, '&::placeholder': {
            opacity: 1,
            color: theme.colors.text[600],
        } }),
    success: {
        borderColor: theme.colors.success.main,
    },
    inTable: {
        '& .MuiTextField-root .MuiInputBase-root': {
            '&, & .MuiInputBase-input': {
                backgroundColor: 'transparent',
            },
            '&:not(:hover):not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
            },
        },
    },
    numberArrowsRemoved: {
        '& .MuiTextField-root .MuiInputBase-root': {
            '&, & .MuiInputBase-input': {
                '&::-webkit-outer-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
                '&::-webkit-inner-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
                '&::[type=number]': {
                    '-moz-appearance': 'textfield' /* Firefox */,
                },
            },
        },
    },
    warning: {
        '& fieldset': {
            borderColor: theme.colors.warning.main,
        },
    },
    helperText: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    errorIcon: {
        height: 13,
        width: 13,
    },
    InputTitle: Object.assign(Object.assign({}, theme.typography.subtitle1), { '&.withPadding': {
            marginBottom: theme.spacing(0.5),
        } }),
    InputSubtitle: Object.assign(Object.assign({}, theme.typography.body3), { color: theme.colors.text[600], marginBottom: theme.spacing(0.5) }),
}));
//# sourceMappingURL=InputField.styles.js.map